import React from "react";
import { useRouteError } from "react-router-dom";
import { T } from "services/lang/LanguageService";

export default function ErrorPage({ msg }: { msg: string }) {
  const error = useRouteError() as Error;
  let errorMessage = msg;
  if (error instanceof Error) {
    errorMessage = error.message;
  } else if (typeof error === "string") {
    errorMessage = error;
  }

  return (
    <div className="text-center mt-3">
      <h1>Oops!</h1>
      <p>{T("error.unexpected-error")}:</p>
      <p>{errorMessage && <i>{errorMessage}</i>}</p>
    </div>
  );
}
